export const SET_BLOCK = 'SET_BLOCK';
export const SET_PREVIOUS_BLOCK = 'SET_PREVIOUS_BLOCK';
export const SET_COOKIE_AGREEMENT = 'SET_COOKIE_AGREEMENT';
export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE';
